import "./clean.css";
import "./index.scss";
import React, { useState } from "react";
import { HashRouter, Routes, Route, Link } from "react-router-dom";
import ModelChoose from "./pages/ModelChoose";
import Formular from "./pages/Formular";
import Layout from "./common/Layout";
import Finish from "./pages/Finish";
function App() {
    return (
        <div className='App'>
            <HashRouter>
                <Layout>
                    <Routes>
                        <Route path='/' element={<ModelChoose />} />
                        <Route path='/model/:id' element={<Formular />} />
                        <Route path='/finish/:id' element={<Finish />} />
                    </Routes>
                </Layout>
            </HashRouter>
        </div>
    );
}

export default App;
